import CartList from "components/common/cart/CartList";
import ManagementSidebar from "components/common/ManagementSidebar";
const CartListPage = () => {
  return (
    <div>
      <div className=" w-100 mt-2 d-flex">
        {/* <ManagementSidebar></ManagementSidebar> */}
        <div className="container">
          <CartList />
        </div>
      </div>
    </div>
  );
};

export default CartListPage;
